import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import AfitdButton from '../../../common/elemental/AfitdButton';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { setClassNameInDefns } from '../../../common/definitionHelper';
import { Grid } from '@material-ui/core';
import SearchInput from '../SearchInput';
import AfitdTypography from '../../../common/elemental/AfitdTypography';
import Rectangle1 from '../../../images/adminConsole/Rectangle1.png';
import Rectangle2 from '../../../images/adminConsole/Rectangle2.png';
import Rectangle3 from '../../../images/adminConsole/Rectangle3.png';
import Rectangle4 from '../../../images/adminConsole/Rectangle4.png';
import AdvertisementRequestsModal from './AdvertisementRequestsModal';
import AfitdPagination from '../../../common/elemental/AfitdPagination';
import { format } from 'date-fns';
import { LayoutContext } from '../../../common/contexts';
import { ADMIN_CONSOLE_PAGE_SIZE } from '../../../common/constants';
// import { useParams } from 'react-router-dom';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        headerTitle: { fontWeight: 500, fontSize: 20 },
        topBarRightItem: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' },
        approveButton: { height: 36, marginRight: 8 },
        selectedText: { paddingRight: 16 },
        rejectButton: { height: 36 },
        topBarContainer: { height: 57.66, border: '1px solid #F3F3F3', padding: '0px 10px' },

        root: {
            width: '100%',
        },
        paper: {
            width: '100%',
            marginBottom: theme.spacing(2),
        },
        table: {
            minWidth: 750,
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1,
        },
        tableRowContainer: {
            maxHeight: 400,
            height: '100%',
            overflowY: 'scroll',
            '&::-webkit-scrollbar-track': {
                borderRadius: '10px',
                background: 'none',
            },
            '&::-webkit-scrollbar': {
                width: '8px',
                backgroundColor: '#F5F5F5',
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
        },
        paginationContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 10,
        },
    }));
};

function createData(avatar, name, illicit, region, country, ad, date) {
    return { avatar, name, illicit, region, country, ad, date };
}

const rows = [
    createData(Rectangle1, 'Cupcakee', 'Not Likely', 'California', 'USA', 'Job Center', '10/5/2020'),
    createData(Rectangle2, 'Donutt', 'Not Likely', 'California', 'USA', 'Job Center', '12/5/2020'),
    createData(Rectangle3, 'Eclaira', 'Not Likely', 'California', 'USA', 'Job Center', '13/5/2020'),
    createData(Rectangle4, 'Frozn yoghurte', 'Not Likely', 'California', 'USA', 'Job Center', '15/5/2020'),
    createData(Rectangle2, 'Gingorbrkade', 'Not Likely', 'California', 'USA', 'Job Center', '17/5/2020'),
    createData(Rectangle1, 'Gingerbreade', 'Not Likely', 'California', 'USA', 'Job Center', '17/5/2020'),
    createData(Rectangle3, 'Honeycomby', 'Not Likely', 'California', 'USA', 'Job Center', '19/5/2020'),
    createData(Rectangle2, 'Eclaaa', 'Not Likely', 'California', 'USA', 'Job Center', '13/5/2020'),
    createData(Rectangle4, 'Ice cream sandwich', 'Not Likely', 'California', 'USA', 'Job Center', '20/5/2020'),
    createData(Rectangle1, 'Jelly Bq', 'Not Likely', 'California', 'USA', 'Job Center', '23/5/2020'),
    createData(Rectangle3, 'Kit Kat', 'Not Likely', 'California', 'USA', 'Job Center', '25/5/2020'),
    createData(Rectangle1, 'Jelly Ben', 'Not Likely', 'California', 'USA', 'Job Center', '23/5/2020'),
    createData(Rectangle3, 'Honey', 'Not Likely', 'California', 'USA', 'Job Center', '19/5/2020'),
    createData(Rectangle2, 'Gingerbrkade', 'Not Likely', 'California', 'USA', 'Job Center', '17/5/2020'),
    createData(Rectangle4, 'Jelly Ba', 'Not Likely', 'California', 'USA', 'Job Center', '23/5/2020'),
];

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

const headCells = [
    { id: 'avatar', numeric: false, disablePadding: true, label: 'Ad Image' },
    { id: 'name', numeric: false, disablePadding: true, label: 'Name' },
    { id: 'state', numeric: false, disablePadding: false, label: 'State' },
    { id: 'country', numeric: false, disablePadding: false, label: 'Country' },
    { id: 'ad', numeric: false, disablePadding: false, label: 'Ad Placement' },
    { id: 'pos', numeric: false, disablePadding: false, label: 'Ad Location' },
    { id: 'date', numeric: false, disablePadding: false, label: 'Date / Time' },
];

const getDefns = params => {
    const { classes } = params;

    const defns = {
        rootContainer: { item: true, xl: 9, lg: 9, md: 9, sm: 9, xs: 9 },
        approveButton: { color: 'secondary' },
        topBarContainer: { container: true, alignItems: 'center' },
        topBarLeftItem: { item: true, xl: 7, xs: 7 },
        topBarRightItem: { item: true, xl: 5, xs: 5 },
        selectedText: { color: 'secondary' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};
function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    // let headStyle = {};

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{ 'aria-label': 'select all desserts' }}
                    />
                </TableCell>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.id === 'date' ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        style={
                            headCell.id === 'avatar'
                                ? { width: 100 }
                                : headCell.id === 'name'
                                ? { width: 210 }
                                : headCell.id === 'illicit'
                                ? { paddingRight: 6.1 }
                                : headCell.id === 'date'
                                ? { paddingLeft: 0 }
                                : headCell.id === 'ad'
                                ? { paddingLeft: 5 }
                                : headCell.id === 'country'
                                ? { padding: '0px 0px 0px 46px' }
                                : null
                        }
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            style={{
                                fontWeight: 'bold',
                                color: '#111E14',
                                opacity: 0.6,
                            }}
                        >
                            {headCell.label}
                            {/* {orderBy === headCell.id ? <span className={classes.visuallyHidden}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</span> : null} */}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = props => {
    const classes = useStyles(/*{param1, param2}*/)();
    // const classes = useToolbarStyles();
    const defns = getDefns({ classes, props });
    const { numSelected } = props;

    return (
        <Grid {...defns.topBarContainer}>
            <Grid {...defns.topBarLeftItem}>
                <SearchInput />
            </Grid>
            <Grid {...defns.topBarRightItem}>
                <div {...defns.selectedTextContainer}>
                    <AfitdTypography {...defns.selectedText}> {numSelected} selected</AfitdTypography>
                </div>
                <div>
                    <AfitdButton {...defns.approveButton}>
                        <CheckCircleIcon />
                        &nbsp;Approve
                    </AfitdButton>
                </div>
                <div>
                    <AfitdButton {...defns.rejectButton}>
                        <HighlightOffRoundedIcon />
                        &nbsp;Reject
                    </AfitdButton>
                </div>
            </Grid>
        </Grid>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const JobSeekerRegistrationsTable = props => {
    // const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const layoutContext = useContext(LayoutContext);
    const { totalCounts } = layoutContext;
    const totalCount = totalCounts?.adRequestCount || 0;
    const totalPage = Math.ceil(totalCount / ADMIN_CONSOLE_PAGE_SIZE);
    const [page, setPage] = React.useState(1);
    // const [start, setStart] = React.useState(0);
    // const [end, setEnd] = React.useState(10);
    let start = page * 10 - 10;
    let end = page * 10;

    const classes = useStyles(/*{param1, param2}*/)();
    // const classes = useToolbarStyles();
    const defns = getDefns({ classes, props });
    // props
    const { selected, setSelected, data, nextOnClick, prevOnClick } = props;

    // const handlePageChange = (event, value) => {
    //     setPage(value);
    // };
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = event => {
        if (event.target.checked) {
            const newSelecteds = rows.map(n => n.uid);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }

        setSelected(newSelected);
    };
    const handleChangePage = (evt, value) => {
        if (value > page) {
            nextOnClick && nextOnClick();
        } else {
            // go to prev unless already at page 1
            if (page !== 1) prevOnClick && prevOnClick();
        }
        setPage(value);
    };
    const isSelected = name => selected.indexOf(name) !== -1;
    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <EnhancedTableToolbar numSelected={selected.length} />

                <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
                    <EnhancedTableHead
                        classes={classes}
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={handleRequestSort}
                        rowCount={data?.length}
                    />
                </Table>

                <TableContainer>
                    <div {...defns.tableRowContainer}>
                        <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
                            <TableBody>
                                {stableSort(data, getComparator(order, orderBy))
                                    .slice(start, end)
                                    .map((row, index) => {
                                        const isItemSelected = isSelected(row.uid);
                                        const labelId = `enhanced-table-checkbox-${index}`;
                                        const page = row.jobCtr ? 'Job Center' : row.talentCtr ? 'Talent Center' : row.empSearch ? 'Employer Search' : 'Unknown Page';
                                        return (
                                            <TableRow
                                                hover
                                                onClick={event => handleClick(event, row.uid)}
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.uid}
                                                selected={isItemSelected}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox checked={isItemSelected} inputProps={{ 'aria-labelledby': labelId }} />
                                                </TableCell>

                                                <TableCell component="th" id={labelId} scope="row" padding="none" style={{ width: 100 }}>
                                                    <AdvertisementRequestsModal avatar={row?.imgUrl} />
                                                </TableCell>
                                                <TableCell component="th" id={labelId} scope="row" padding="none" style={{ fontWeight: 'bold' }}>
                                                    {row?.companyName}
                                                </TableCell>
                                                <TableCell align="left">{row?.state}</TableCell>
                                                <TableCell align="left">{row.country}</TableCell>
                                                <TableCell align="left">{page}</TableCell>
                                                <TableCell align="left">{row?.pos}</TableCell>
                                                <TableCell align="right">
                                                    {row?.startDt && format(row?.startDt, 'MM/dd/yyyy')} - {row?.startDt && format(row?.startDt, 'hh:mm')}{' '}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </div>
                </TableContainer>
            </Paper>
            <div {...defns.paginationContainer}>
                <AfitdPagination count={totalPage} color="secondary" page={page} onChange={handleChangePage} disablePage={true} />
            </div>
        </div>
    );
};

export default JobSeekerRegistrationsTable;
